import React, { ComponentType } from 'react';
import { Route } from 'react-router-dom';
import { useHistory } from 'react-router';
import { useAuth } from '../hooks/useAuth';
import Loading from '../components/Common/Loading';
import { ROUTES } from '../constants/route';
import { UserRoles } from '../constants/role';
import NotFoundPage from '../pages/NotFoundPage/NotFoundPage';

export interface ProtectedRouteProps {
  Component: ComponentType;
  accessRole?: UserRoles;
  path?: string;
  exact?: boolean;
  default?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  Component,
  accessRole = UserRoles.PDA,
  ...rest
}) => {
  const history = useHistory();
  const { role, loading, isAuthenticated } = useAuth();

  if (loading) {
    return <Loading />;
  }

  if (!isAuthenticated) {
    history.push(ROUTES.MERCHANT_LOGIN);
  }

  if (role !== accessRole) return <NotFoundPage />;

  return (
    <Route {...rest}>
      <Component {...rest} />
    </Route>
  );
};

export default ProtectedRoute;
